module.exports = __webpack_public_path__ + "img/ch-energy.79a7587e.jpg";